// extracted by mini-css-extract-plugin
export default {"newsSection":"style_newsSection__4pV22"};